import { createContext, useContext } from 'react'

const HomeContext = createContext({})

export const useHomeContext = () => useContext(HomeContext)

export { HomeContext }
